import { gql } from "apollo-angular";

export const ReportContentQuery = gql`
    mutation ReportContentGQL($message: CreateReportContent!) {
        reportContent(data: $message) {
            id
            userId
            timelineEntryId
            timelineInteractionId
            createdAt
            __typename
        }
    }
`